import Vue from 'vue';
import Vuetify, { VDatePicker, VTextField, VMenu } from 'vuetify/lib';
import { Resize, Ripple } from 'vuetify/lib/directives';

import fr from 'vuetify/src/locale/fr';

// Import custom icons components
import NextIcon from '@/components/icons/NextIcon.vue';
import PrevIcon from '@/components/icons/PrevIcon.vue';
import DownIcon from '@/components/icons/DownIcon.vue';

// Import theme colors
import colors from '@/theme/colors';

Vue.use(Vuetify);

export default new Vuetify({
	theme: {
		themes: {
			light: {
				...colors
			}
		}
	},
	// Global compoennts
	components: {
		VDatePicker,
		VTextField,
		VMenu
	},
	lang: {
		locales: { fr },
		current: 'fr'
	},
	directives: {
		Resize,
		Ripple
	},
	icons: {
		iconfont: 'mdiSvg',
		values: {
			next_slide_group: {
				component: NextIcon
			},
			prev_slide_group: {
				component: PrevIcon
			},
			down_expansion_panel: {
				component: DownIcon
			}
		}
	}
});

// Import Vuetify's CSS
import 'vuetify/dist/vuetify.min.css';
